import { jsx as _jsx } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { baseFiltersOptions } from "~/components/FiltersMenu/types";
export const getFilterProps = (param)=>{
    let { type, onSelect, isSelected, disabled } = param;
    const Prefix = baseFiltersOptions[type].icon;
    return {
        disabled: disabled || isSelected,
        id: baseFiltersOptions[type].id,
        label: baseFiltersOptions[type].label,
        onSelect: ()=>onSelect(baseFiltersOptions[type].id),
        prefix: Prefix ? /*#__PURE__*/ _jsx(Prefix, {
            className: "size-4 text-grey-10"
        }) : null,
        suffix: isSelected ? /*#__PURE__*/ _jsx(Check, {
            className: "size-4 text-grey-10"
        }) : null
    };
};
